/**
 * Helper to see if the given barcode is actually a json with parcelId and pickupCode
 * we call this our QR pickup code (QR afhaalcode)
 */
export const withPickupCode = (input: string | null): { parcelId: string; pickupCode: string } | null => {
  if (!input) {
    return null
  }

  try {
    const data = input.startsWith('{') && input.endsWith('}') ? JSON.parse(input) : null
    if (data?.parcelId) {
      return data
    }
    return null
  } catch {
    return null
  }
}
